export const MODALS_SLICE = 'MODALS_SLICE';
